<div
  class="floating-dialog-wrapper"
  [class.minimized]="dialog.minimized"
  cdkDrag
  cdkDragBoundary=".floating-dialogs-host"
  (cdkDragEnded)="onDragEnded($event)"
  [style.left.px]="dialog.position.x"
  [style.top.px]="dialog.position.y"
  [style.height.px]="dialog.height ?? null"
  [style.width.px]="dialog.width ?? null"
  [style.z-index]="dialog.zIndex"
  (mousedown)="onFocus()"
>
  <!-- Title bar — drag handle -->
  <div class="dialog-title-bar" cdkDragHandle>
    <mat-icon class="drag-icon">drag_indicator</mat-icon>
    <span class="dialog-title" [title]="dialog.title">{{ dialog.title }}</span>
    <div class="dialog-title-actions" (mousedown)="$event.stopPropagation()">
      @if (mainWindowRoute) {
        <button
          mat-icon-button
          class="dialog-action-btn"
          matTooltip="Open in main window"
          (click)="onOpenInMainWindow()"
        >
          <mat-icon>open_in_full</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        class="dialog-action-btn"
        [matTooltip]="dialog.minimized ? 'Restore' : 'Minimize'"
        (click)="toggleMinimize()"
      >
        <mat-icon>{{ dialog.minimized ? 'expand_more' : 'remove' }}</mat-icon>
      </button>
      <button
        mat-icon-button
        class="dialog-action-btn"
        matTooltip="Close"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content area — hidden when minimized -->
  @if (!dialog.minimized) {
    <div class="dialog-content">
      <ng-container
        [ngComponentOutlet]="dialog.component"
        [ngComponentOutletInputs]="dialog.inputs ?? {}"
      />
    </div>
  }
</div>
